var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"margin-bottom":"7px"},attrs:{"small":"","color":"info"},on:{"click":_vm.saveConfig}},[_vm._v("Save Config")])}
var staticRenderFns = []

export { render, staticRenderFns }